<template>
  <b-modal v-model="show" has-modal-card :can-cancel="['escape', 'outside']" @close="onClose">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">v1.1.2</p>
          <button type="button" class="delete" v-on:click="onClose"/>
        </header>
        <section class="modal-card-body">
          <div class="is-size-5 has-text-weight-bold">Made by Taro</div>
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <b-icon pack="fab" icon="twitter-square" size="is-large"></b-icon>
            <a class="ml-1 has-text-weight-bold has-text-info" href="https://twitter.com/Tarolewd" target="_blank">@Tarolewd</a>
          </div>
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <b-icon pack="fab" icon="discord" size="is-large"></b-icon>
            <a class="ml-1 has-text-weight-bold has-text-info" href="https://discord.com/invite/V2EKfyDpV6" target="_blank">Kaa's Treetop</a>
          </div>
          <div class="is-size-5 has-text-weight-bold mt-4">Sources</div>
          <div class="content">
            <ul class="mt-0">
              <li>'Kaa ASMR' (Audio) by <a class="has-text-weight-bold has-text-info" href="https://www.youtube.com/channel/UCdFPB-7oRVyT74kBaDwid5Q" target="_blank">m5a5e5</a></li>
            </ul>
          </div>
        </section>
        <footer class="modal-card-foot"></footer>
      </div>
    </b-modal>
</template>

<script>
export default {
  props: {
    showInfo: Boolean
  },
  data: function () {
    return {
      show: this.showInfo
    }
  },
  watch: {
    showInfo: function (newValue) {
      this.show = newValue
    }
  },
  methods: {
    onClose: function () {
      this.$emit('update:showInfo', false)
    }
  }
}
</script>

<style>

</style>
